import React from 'react';
import './style.css';



const PageAcordes = () => {
  

  return (
    <>
      <div id="container-page-acordes">
        <h1>PAGINA DE ACORDES EM CONSTRUÇÃO</h1>

       
      </div>
    </>
  )
}

export default PageAcordes